import { Tabs as TabsAntd } from 'antd';
import { TabsProps as TabsPropsAntd } from 'antd/es/tabs';

import styled, { css, StyledProp } from '@/styled';

interface TabsProps extends StyledProp {
  hasContent?: boolean;
}

const Tabs = (props: TabsProps & TabsPropsAntd) => {
  return <TabsAntd tabPosition='top' type='line' {...props} />;
};

export default styled(Tabs)(
  ({ theme }) => css`
    max-width: 100%;

    .ant-tabs-nav {
      margin: 0;
    }

    .ant-tabs-nav::before {
      border-bottom: none;
    }

    .ant-tabs-ink-bar {
      bottom: 0px;
    }

    .ant-tabs-tab {
      padding: 0;
      font-size: ${theme.space.pxToRem(16)};
    }

    .ant-tabs-nav-operations {
      display: none;
    }

    .ant-tabs-tab-active {
      font-weight: ${theme.fontWeightStrong};
    }

    .ant-tabs-nav {
      background: ${theme.variables.tabs.headerBackground};
      padding: ${theme.space.spacing(0, 6)};
      width: 100%;
    }

    .ant-tabs-nav-wrap {
      height: 48px;
    }

    .ant-tabs-tab {
      padding: 0;
      font-size: ${theme.fontSize}px;
      color: ${theme.colorTextBase};
    }

    .ant-tabs-tab-active > .ant-tabs-tab-btn {
      color: ${theme.colorTextBase};
    }

    .ant-tabs-content {
      background: ${theme.variables.tabs.contentBackground};
      padding: ${theme.space.pxToRem(24)};
    }
  `
);
